import React from 'react';
import { useSelector } from 'react-redux';

import { selectMvtPages } from '../selectors/detailsSelectors';
import BrowseOrientedStockItemCategoryLinks from './BrowseOrientedCategoryLinks/BrowseOrientedStockItemCategoryLinks';

const BrowseSimilarCategories = ({ categories, contentType }) => {
  const mvtPages = useSelector(selectMvtPages);
  return (
    <div className="stockItemDetails-row md:col-start-1 md:row-start-2 md:row-end-3 md:col-end-4">
      <div className="stockItemDetails-section">
        <BrowseOrientedStockItemCategoryLinks
          categories={categories}
          contentType={contentType}
          mvtPages={mvtPages}
          linkClassName="flex-wrap gap-y-3 gap-x-2"
          pillButtons={true}
        />
      </div>
    </div>
  );
};

export default BrowseSimilarCategories;
